/* Thaheb storewide Buy 1, get the 2nd 50% off + Buy 2, get the 3rd free (2026-11-01): countdown, eligibility reveal, cart nudge, email popup.
   Offer: automatic Shopify discount, every jewellery piece priced over AUD 40. */
(function (w, d) {
  if (w.__tbogo) return;
  w.__tbogo = 1;
  var MIN_AUD_CENTS = 4000;
  var SUBSCRIBE = 'https://mailflow-rho-three.vercel.app/api/subscribe/ce7b7f94-4593-4b9e-a1ca-b61cca54fa20';
  var ls = null;
  try { ls = w.localStorage; } catch (e) {}
  function lget(k) { try { return ls ? ls.getItem(k) : null; } catch (e) { return null; } }
  function lset(k, v) { try { if (ls) ls.setItem(k, v); } catch (e) {} }

  function rate() {
    var r = 1;
    try { r = parseFloat(w.Shopify && w.Shopify.currency && w.Shopify.currency.rate); } catch (e) {}
    return r > 0 ? r : 1;
  }
  function eligible(cents) { return +cents / rate() > MIN_AUD_CENTS; }

  /* ---- countdown to the shopper's local midnight ---- */
  function pad(n) { return ('0' + n).slice(-2); }
  function tick() {
    var els = d.querySelectorAll('[data-tbogo-timer]');
    if (!els.length) return;
    var n = new Date();
    var s = Math.max(0, Math.round((new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1) - n) / 1000));
    var t = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== t) els[i].textContent = t;
  }

  /* ---- reveal offer cards / badges for non-AUD shoppers (price converted back to AUD) ---- */
  function reveal(root) {
    var els = (root || d).querySelectorAll('[data-tbogo-cents][hidden]');
    for (var i = 0; i < els.length; i++) if (eligible(els[i].getAttribute('data-tbogo-cents'))) els[i].hidden = false;
  }

  /* ---- cart nudge ---- */
  var cartState = null, cartBusy = false, cartAgain = false;
  var OFFER_RE = /buy 1, get (1|the 2nd) 50% off|buy 2, get the 3rd free|thbogoqaiqg0q/i;
  function money(cents, cur) {
    var v = Math.round((+cents || 0) / 100);
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(v); }
    catch (e) { return '$' + v; }
  }
  function analyse(c) {
    var units = 0, saved = 0, items = c.items || [], i, j, it, ds;
    for (i = 0; i < items.length; i++) {
      it = items[i];
      if (eligible(it.original_price != null ? it.original_price : it.price)) units += it.quantity;
      ds = it.discounts || [];
      for (j = 0; j < ds.length; j++) if (OFFER_RE.test(ds[j].title || '')) saved += ds[j].amount || 0;
    }
    return { units: units, saved: saved, other: (c.total_discount || 0) > saved, currency: c.currency };
  }
  function line(t, s) { return '<p class="tbogo-nudge__t">' + t + '</p><p class="tbogo-nudge__s">' + s + '</p>'; }
  function nudgeHtml(a) {
    if (a.units < 1) return '';
    if (a.units === 1) return line('Add a 2nd piece for 50% off', 'Or get 3 for the price of 2');
    if (a.saved > 0) return line('You\'re saving ' + money(a.saved, a.currency), a.units === 2 ? 'Add a 3rd piece and it\'s free' : a.units % 3 === 2 ? 'Add one more piece and it\'s free' : a.units === 3 ? 'Your 3rd piece is free' : 'Every 3rd piece is free');
    if (a.other) return '';
    return line('Buy 1, get the 2nd 50% off', 'Applied automatically at checkout');
  }
  function paint() {
    var els = d.querySelectorAll('[data-tbogo-nudge]');
    if (!els.length || !cartState) return;
    var a = analyse(cartState), h = nudgeHtml(a), ok = !!(a.saved > 0 && a.units >= 2);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-tbogo-h') === h && el.hidden === !h && el.classList.contains('tbogo-nudge--ok') === ok) continue;
      el.setAttribute('data-tbogo-h', h);
      el.innerHTML = h;
      el.hidden = !h;
      el.classList.toggle('tbogo-nudge--ok', !!ok);
    }
  }
  function refreshCart() {
    if (cartBusy) { cartAgain = true; return; }
    cartBusy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { cartState = c; fresh++; paint(); } })
      .catch(function () {})
      .then(function () { cartBusy = false; if (cartAgain) { cartAgain = false; refreshCart(); } });
  }
  // The cart sections carry their own numbers (snippets/thaheb-bogo-nudge.liquid), so the message is worded in the same
  // frame the cart re-renders, with no extra /cart.js round trip. An element is read again only when its numbers change.
  var fresh = 0;
  function ssrRead() {
    var els = d.querySelectorAll('[data-tbogo-cart]'), got = false;
    for (var i = 0; i < els.length; i++) {
      var el = els[i], s = el.getAttribute('data-tbogo-cart');
      if (!s || el.__tbogoSeen === s) continue;
      el.__tbogoSeen = s;
      try { var c = JSON.parse(s); if (c && c.items) { cartState = c; got = true; } } catch (e) {}
    }
    if (got) fresh++;
    return got;
  }
  var cartTmr = 0;
  function cartSoon(force) {
    clearTimeout(cartTmr);
    cartTmr = setTimeout(function () {
      if (force !== true && ssrRead()) { paint(); return; }
      if (d.querySelector('[data-tbogo-nudge]')) refreshCart();
    }, 250);
  }

  // a full cart on the event is used as is; otherwise the re-rendered section brings the numbers
  d.addEventListener('cart:update', function (e) {
    var r = e && e.detail && e.detail.resource;
    if (r && r.items) { cartState = r; fresh++; paint(); }
  });
  ['cart:refresh', 'discount:update'].forEach(function (n) { d.addEventListener(n, function () { cartSoon(); }); });
  // safety net: a cart write that no re-render followed still refreshes the message
  if (w.fetch) {
    var of = w.fetch;
    w.fetch = function (input) {
      var p = of.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          var seen = fresh;
          p.then(function () { setTimeout(function () { ssrRead(); if (fresh === seen) cartSoon(true); else paint(); }, 800); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  /* ---- DOM watcher: new cards / re-rendered cart parts ---- */
  var domTmr = 0;
  function onDom() {
    // same task as the re-render, so the message never shows a wrong size or wording first
    if (d.querySelector('[data-tbogo-nudge]')) { if (ssrRead() || cartState) paint(); else refreshCart(); }
    clearTimeout(domTmr);
    domTmr = setTimeout(function () { tick(); reveal(); }, 60);
  }

  /* ---- email popup ---- */
  var pop, lastFocus, shownAt = 0, popTimer = 0, added = false;
  try { added = !!w.sessionStorage.getItem('tbogo_added'); } catch (e) {}
  d.addEventListener('thaheb:cart-adding', function () {
    added = true;
    try { w.sessionStorage.setItem('tbogo_added', '1'); } catch (e) {}
    clearTimeout(popTimer);
  });
  // a tap, scroll or key press in the last moment means the shopper is mid-action: the popup waits for a pause
  var lastAct = 0;
  ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel'].forEach(function (n) { w.addEventListener(n, function () { lastAct = Date.now(); }, { capture: true, passive: true }); });
  function busyFor(exit) {
    if (d.querySelector('dialog[open], cart-drawer-component[open], .cart-drawer__dialog[open]')) return 4000;
    var a = d.activeElement;
    if (a && a !== d.body && !(pop && pop.contains(a)) && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return 4000;
    var idle = Date.now() - lastAct;
    return !exit && idle < 1500 ? 1600 - idle : 0;
  }
  function blocked() {
    if (!pop) return true;
    if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/(cart|checkouts?)(\/|$)/i.test(w.location.pathname) || /\/products\//.test(w.location.pathname)) return true;
    if (lget('tbogo_signed')) return true;
    var until = +lget('tbogo_pop_until') || 0;
    return until > Date.now();
  }
  function openPop(exit) {
    if (blocked() || pop.classList.contains('is-open')) return;
    exit = exit === true;
    if (!exit && added) return;
    var wait = busyFor(exit);
    if (wait) { if (!exit) { clearTimeout(popTimer); popTimer = setTimeout(openPop, wait); } return; }
    lastFocus = d.activeElement;
    pop.hidden = false;
    void pop.offsetWidth;
    pop.classList.add('is-open');
    lset('tbogo_pop_until', String(Date.now() + 7 * 864e5));
    var em = pop.querySelector('input[name="email"]');
    if (em) setTimeout(function () { try { em.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closePop() {
    if (!pop) return;
    pop.classList.remove('is-open');
    setTimeout(function () { if (!pop.classList.contains('is-open')) pop.hidden = true; }, 300);
    try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  function initPop() {
    pop = d.getElementById('tbogo-pop');
    if (!pop || blocked()) return;
    pop.addEventListener('click', function (e) {
      if (e.target === pop || (e.target.closest && e.target.closest('[data-tbogo-close]'))) closePop();
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) closePop();
      else if (e.key === 'Tab' && pop.classList.contains('is-open')) {
        var f = pop.querySelectorAll('button:not([disabled]),input,a[href]'), v = [], i;
        for (i = 0; i < f.length; i++) if (f[i].offsetParent !== null) v.push(f[i]);
        if (!v.length) return;
        if (e.shiftKey && d.activeElement === v[0]) { e.preventDefault(); v[v.length - 1].focus(); }
        else if (!e.shiftKey && d.activeElement === v[v.length - 1]) { e.preventDefault(); v[0].focus(); }
      }
    });
    var form = pop.querySelector('form'), err = pop.querySelector('[data-tbogo-err]'), btn = form.querySelector('button[type="submit"]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.elements.email.value || '').trim(), first = (form.elements.firstName.value || '').trim();
      err.textContent = '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Please enter a valid email address.'; form.elements.email.focus(); return; }
      btn.disabled = true;
      var body = { email: email }; if (first) body.firstName = first;
      fetch(SUBSCRIBE, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          if (r.status === 200 || r.status === 201) { lset('tbogo_signed', '1'); pop.classList.add('is-done'); var a = pop.querySelector('.tbogo-pop__ok a'); if (a) a.focus(); return; }
          if (r.status >= 500) { err.textContent = 'Sign-ups are paused for a moment, but the offer is already on: it applies automatically at checkout.'; return; }
          return r.json().catch(function () { return {}; }).then(function (j) {
            err.textContent = (j && (j.error || j.message)) || 'Something went wrong. Please try again.';
          });
        })
        .catch(function () { err.textContent = 'Sign-ups are paused for a moment, but the offer is already on: it applies automatically at checkout.'; })
        .then(function () { btn.disabled = false; });
    });
    popTimer = setTimeout(openPop, 8000);
    // desktop exit intent
    if (w.matchMedia && w.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      d.documentElement.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) openPop(true); });
    }
  }


  /* Keep typed personalisation when switching between sibling chain products */
  var KEEP = ['properties[Name]', 'properties[Language]', 'properties[Other Language]', 'properties[Chain Length]'];
  function keepKey(n) { return 'tbogo_keep_' + n; }
  function keepSave(e) {
    var t = e.target; if (!t || !t.name || KEEP.indexOf(t.name) < 0) return;
    if (t.type === 'radio' && !t.checked) return;
    try { sessionStorage.setItem(keepKey(t.name), t.value); } catch (x) {}
  }
  function keepRestore() {
    KEEP.forEach(function (n) {
      var v; try { v = sessionStorage.getItem(keepKey(n)); } catch (x) {} if (!v) return;
      var els = d.getElementsByName(n); for (var i = 0; i < els.length; i++) {
        var el = els[i]; if (el.dataset.tbogoKept) continue;
        if (el.type === 'radio') { if (el.value !== v) continue; if (el.checked) { el.dataset.tbogoKept = '1'; continue; } el.checked = true; }
        else if (el.tagName === 'SELECT') { var ok = false; for (var k = 0; k < el.options.length; k++) if (el.options[k].value === v) ok = true; if (!ok || el.value === v) { el.dataset.tbogoKept = '1'; continue; } el.value = v; }
        else { if (el.value) { el.dataset.tbogoKept = '1'; continue; } el.value = v; }
        el.dataset.tbogoKept = '1';
        el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  d.addEventListener('input', keepSave, true); d.addEventListener('change', keepSave, true);
  (function () { var n = 0, t = setInterval(function () { keepRestore(); if (++n > 20) clearInterval(t); }, 500); })();

  /* Fallback: if the section re-render for a colour change fails (throttled or offline), still show that variant's image first */
  function galleryFallback() {
    var vid = new URLSearchParams(location.search).get('variant'), tag = d.querySelector('script[data-tbogo-vmedia]'); if (!vid || !tag) return;
    var map; try { map = JSON.parse(tag.textContent); } catch (x) { return; }
    var mid = map[vid]; if (!mid) return;
    var g2 = d.querySelector('media-gallery'), box = g2 && g2.querySelector('slideshow-slides'); if (!box) return;
    var slides = box.querySelectorAll(':scope > slideshow-slide'), pick = null;
    for (var i = 0; i < slides.length; i++) if (slides[i].querySelector('[data-media-id="' + mid + '"]')) { pick = slides[i]; break; }
    if (!pick || pick === slides[0]) return;
    box.insertBefore(pick, slides[0]);
    if (g2.slideshow && g2.slideshow.select) { try { g2.slideshow.select(0, undefined, { animate: false }); } catch (x) {} }
  }
  d.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(galleryFallback, 2500); }, true);

  function init() {
    tick();
    setInterval(tick, 1000);
    reveal();
    if (w.MutationObserver) new MutationObserver(onDom).observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-tbogo-cart'] });
    if (d.querySelector('[data-tbogo-nudge]')) { if (ssrRead()) paint(); else refreshCart(); }
    initPop();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})(window, document);
